<template>
  <main class="page-auth"></main>
</template>

<script>
import authService from "../service/authService";
import LS from "local-storage";

export default {
  name: "auth",

  mounted() {
    this.getHash();
  },
  methods: {
    getHash() {
      let params = new URLSearchParams(location.search.substring(1));
      const hash = params.get("hash");
      if (hash) {
        authService.handleAuth(hash)
            .then(res => {
              LS.set('token', res.data.token)
              this.$router.push({
                path: "/"
              })
            })
            .catch(err => {
              console.log(err)
            })
      }

    },
  }
}
</script>

<style scoped>

</style>